<template>
  <div>
    <div :id="$id('keep_value')">
      <b-form-checkbox
        v-model="local_checked"
        :value="true"
        :unchecked-value="false"
        >{{ name }}</b-form-checkbox
      >
    </div>
    <b-tooltip :target="$id('keep_value')" :delay="{ show: 1000, hide: 0 }">{{
      name
    }}</b-tooltip>
  </div>
</template>

<script>
import _ from 'lodash'

import { tagid_mixin } from '@/components/mixin.js'

// *****************************************************************************

export default {
  name: 'FilterSearchListElement',
  mixins: [tagid_mixin],
  props: ['item'],
  data() {
    return {
      local_checked: false,
    }
  },
  computed: {
    name() {
      return (this.item || {}).name
    },
  },
  watch: {
    item: {
      deep: true,
      handler(v) {
        if (!_.isEqual((v || {}).checked || false, this.local_checked)) {
          this.local_checked = (v || {}).checked || false
        }
      },
    },
    local_checked(nv, ov) {
      if (
        !_.isEqual(nv, this.item.checked) &&
        !_.isUndefined(nv) &&
        !_.isUndefined(this.item.name) &&
        !_.isUndefined(this.item.checked)
      ) {
        this.$emit('actualize_checked', {
          name: this.name,
          checked: nv,
        })
      }
    },
  },
}
</script>
